module.exports = __webpack_public_path__ + "img/GAME_SEAOFFANTASY1.77d3a581.jpg";